import { Box, Button, Typography } from '@mui/material';

import axiosApiInstance from '@/api/shared/axios-instance';
import JugadoresV2Component from '@/components/jugadores-v2';
import { FANTASY } from '@/helpers/biwenger-helper';
import URL_FACTORY from '@/helpers/url-helper';
import Seo from '@/components/shared/custom/seo-component';
import { Pages, Rutas } from '@/constants/rutas';
import {
    getCurrentSeason,
    getFantasyLaLigaProperties,
    GetJugadoresAdditionalData,
} from '@/components/jugadores-v2/information/jugadores-additional-data';
import { getMasterPhotoById } from '@/helpers/images-helper';
import { currentSeason } from '@/constants/site';
import { IsrRevalidateTime } from '@/constants/cache-state-constants';
import NoDataComponent from '@/components/shared/no-data-component';
import Link from 'next/link';

const JugadoresPage = ({ player, slug }) => {
    const nombre = player?.if?.nm;
    const nombreDeEquipo = player?.team?.name;

    const season = getCurrentSeason();
    const title = `Estadísticas La Liga Fantasy Dazn de ${nombre} - ${season}`;
    const description = `Estadísticas de ${nombre} en clave La Liga Fantasy Dazn, calendario, alineaciones probables, lesiones y noticias en clave La Liga Fantasy Dazn.`;
    const url = `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.ESTADISTICAS_DEL_JUGADOR}/${slug.join('/')}`;
    const image = getMasterPhotoById(player?.if?.id, 375);

    const properties = getFantasyLaLigaProperties(player);
    const customSeoSchema = GetJugadoresAdditionalData(player, url, properties);

    return (
        <Box className="container" mt={2}>
            <Seo
                pageId={Pages.JUGADORES}
                title={title}
                image={image}
                url={url}
                description={description}
                summary={'summary'}
                customSeoSchema={customSeoSchema}
                width={500}
                height={500}
            />

            <Typography variant="h1">
                {nombre} - La Liga Fantasy Dazn {season} - {nombreDeEquipo}
            </Typography>

            {!player?.if?.id && (
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <NoDataComponent
                        title="No se ha encontrado el jugador"
                        description="Prueba jugar a la Ruleta Fantasy."
                        margin="0 auto"
                        width="100%"
                    />

                    <Button variant="contained" color="primary" fullWidth mt={2}>
                        <Link href={Rutas.RULETA_FANTASY} prefetch={false}>
                            Jugar a la Ruleta Fantasy
                        </Link>
                    </Button>
                </Box>
            )}

            {player?.if?.id > 0 && (
                <JugadoresV2Component player={player} mode={FANTASY.FANTASY} slug={slug} activeSubTab={0} />
            )}
        </Box>
    );
};

export default JugadoresPage;

// ✅ Usamos getStaticProps con revalidate para ISR
export async function getStaticProps({ params }) {
    const { slug } = params;

    if (!slug || slug.length === 0) {
        return {
            notFound: true,
        };
    }

    const playerSlug = slug?.[0];
    const year = slug?.[1] ?? currentSeason;

    let response = {};

    try {
        const url = URL_FACTORY.GetPlayerInformation;

        const payload = {
            slug: playerSlug,
            season: year,
        };

        response = await axiosApiInstance.post(url, payload);
    } catch (error) {
        console.error('Error fetching player profile:', error);
        return {
            props: {
                slug,
                player: null,
            },
            revalidate: 5,
        };
    }

    const player = response.data;

    return {
        props: {
            slug,
            player,
        },
        revalidate: IsrRevalidateTime.JUGADORES_PAGE, // Define el tiempo de revalidación
    };
}

// ✅ Generamos paths vacíos y usamos fallback para generar dinámicamente
export async function getStaticPaths() {
    return {
        paths: [], // No pre-generamos nada
        fallback: 'blocking', // Generamos dinámicamente si no existe
    };
}
